import { Component, OnInit, Inject, EventEmitter, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { environment } from 'environments/environment';
import * as moment from 'moment';

@Component({
  selector: 'app-turn-dialog-dialog-container',
  templateUrl: './turn-dialog-container.component.html',
  styleUrls: ['./turn-dialog-container.component.scss'],
})

export class TurnDialogComponent implements OnInit, OnDestroy {
  _GAMES;
  imgURLHandle = environment.URL_TEAM_IMAGES;
  league = 'NBA';
  draftGameEmitter = new EventEmitter();
  draftPickCounter: string;
  _SELECTED_GAME;
  timerSubscriber;

  constructor(
    public dialogRef: MatDialogRef<TurnDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.draftPickCounter = data.count;
    dialogRef.disableClose = true;
    this.filterGamesForDisplay(data.games);
    this.timerSubscriber = data.timer.subscribe(res => {
      this.draftPickCounter = res.countdown.toLocaleString('en-US', { minimumIntegerDigits: 1, useGrouping: false });
    });
    this.selectDefaultSelectedGame();
  }

  selectDefaultSelectedGame() {
    this._GAMES[0]['gameSelected'] = true;
    this._SELECTED_GAME = this._GAMES[0];
  }

  draft() {
    this.draftGameEmitter.emit(this._SELECTED_GAME);
    this.dialogRef.close();
    this._SELECTED_GAME = null;
  }

  filterGamesForDisplay(allGamesArray) {
    const queuedGames = allGamesArray.filter(element => {
      return element.isQueued === true;
    });

    queuedGames.sort((a, b) => parseFloat(a.q_tstamp) - parseFloat(b.q_tstamp));
    const nonQueuedGames = allGamesArray.filter(element => {
      return element.isQueued === false || !element.isQueued;
    });
    this._GAMES = queuedGames.concat(nonQueuedGames);
    this._GAMES[0]['gameSelected'] = true;
    this._SELECTED_GAME = this._GAMES[0];
  }

  addEvent(num: any) {
    for (let i = 0; i < this._GAMES.length; i++) {
      if (i !== num) {
        this._GAMES[i]['gameSelected'] = false;
      }
    }
    this._GAMES[num]['gameSelected'] = true;
    this._SELECTED_GAME = this._GAMES[num];
  }

  draftGame(game) {
    this.draftGameEmitter.emit(game);
    this.dialogRef.close();
  }

  ngOnInit() { }

  ngOnDestroy() {
    this.timerSubscriber.unsubscribe();
  }

  date(date) {
    return moment(date).format('dddd, MMM Do');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/draft/dialogs/turn-dialog-container/turn-dialog-container.component.ts